<style lang="scss" scoped>
.password__feedback {
    align-items: center;
    display: inline-block;
    font-size: 10px;

    > i {
        margin-right: 2px;
    }

    &--invalid, &--valid {
        margin-top: 2px;
        margin-right: 10px;
    }

    &--invalid {
        color: red;
    }

    &--valid {
        color: green;
    }
}

</style>
<style lang="scss">
.Password {
    max-width: none !important;
    margin: 0 !important;

    .form-control {
        padding: 5px 18px;
        border-color: #ddd;

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;

        }
    }
}
</style>
<template>
    <div>
        <template>
            <password
                    :id="'inputPassword4'"
                    v-bind:value="value"
                    v-model="password"
                    :toggle="true"
                    :badge="false"
                    :secureLength="8"
                    :defaultClass="'form-control'"
                    :showStrengthMeter="false"
                    placeholder="New password *"/>
            <div class="password__feedback">
                <div :class=validFeedBack(regexes.atLeastOneUpperCaseRegex)>
                    <i :class="validIcon(regexes.atLeastOneUpperCaseRegex)"/>Uppercase
                </div>
                <div :class=validFeedBack(regexes.atLeastOneLowerCaseRegex)>
                    <i :class="validIcon(regexes.atLeastOneLowerCaseRegex)"/>Lowercase
                </div>
                <div :class=validFeedBack(regexes.atLeastOneDigitRegex)>
                    <i :class="validIcon(regexes.atLeastOneDigitRegex)"/>Digit
                </div>
                <div :class=validFeedBack(regexes.atLeastOneSpecialCharRegex)>
                    <i :class="validIcon(regexes.atLeastOneSpecialCharRegex)"/>Special character
                </div>
                <div :class=validFeedBack(regexes.atLeastEightCharRegex)>
                    <i :class="validIcon(regexes.atLeastEightCharRegex)"/>8 characters
                </div>
                <div v-if="includePasswordHistory" :class="validFeedBackPasswordHistory(passwordUnique)">
                    <i :class="validIconPasswordHistory(passwordUnique)"/> Password History
                </div>
            </div>
            <div v-if="submitted && !isPasswordValid()" class="password__feedback--invalid">
                <p>
                    Password must be at least 8 characters, including one uppercase
                    letter, one lowercase letter and one digit, with no spaces. Special
                    characters allowed !@#$%^(){}[]:;"'<>,.?/-_. ></p>
                <p v-if="includePasswordHistory">New password should be different from the 5 last passwords by at least 1 character.</p>
            </div>
        </template>
    </div>
</template>
<script>
import password from "vue-password-strength-meter";
import Dashboard from "@/components/Dashboard";
import {mapGetters} from "vuex";
import {UserService} from "@/common/api.service";
import {debounce} from "@riophae/vue-treeselect/src/utils";

export default {
    name: "PasswordFieldWithStrengthMeter",
    components: {
        Dashboard,
        password
    },
    props: ["value", "email", "includePasswordHistory", "token", "submitted"],
    data() {
        return {
            password: null,
            passwordUnique: false,
            iteration: 1,
            regexes: {
                atLeastOneDigitRegex: /\d/,
                atLeastOneUpperCaseRegex: /[A-Z]/,
                atLeastOneLowerCaseRegex: /[a-z]/,
                atLeastOneSpecialCharRegex: /[^\w\s]/,
                atLeastEightCharRegex: /.{8,}/,
            },
        }
    },
    watch: {
        password(newValue) {
            if (this.$props.includePasswordHistory) {
                this.checkPassword();
            }
            this.emitValue("input", newValue);
        }
    },
    methods: {
        isPasswordValid: function () {
            let result = this.regexes.atLeastOneUpperCaseRegex.test(this.$props.value) &&
                    this.regexes.atLeastOneLowerCaseRegex.test(this.$props.value) &&
                    this.regexes.atLeastEightCharRegex.test(this.$props.value) &&
                    this.regexes.atLeastOneDigitRegex.test(this.$props.value) &&
                    this.regexes.atLeastOneSpecialCharRegex.test(this.$props.value);

            if (this.includePasswordHistory) {
                result = result && this.passwordUnique;
            }
            return result;
        },
        checkPassword: debounce(function () {

            const pass = this.password;
            return UserService.isPasswordNew({
                email: this.$props.email,
                passwordResetToken: this.$props.token,
                password: pass
            }).then(response => {
                if (response.status === 200 && response.data.passwordNew === true) {
                    this.emitValue("valid", true);
                    this.passwordUnique = true;
                    return true;
                } else {
                    this.emitValue("valid", false);
                    this.passwordUnique = false;
                    return false;
                }
            }).catch(() => {
                this.emitValue("valid", false);
                this.passwordUnique = false;
                return false;
            });
        }, 500),
        emitValue(type, value) {
            this.$emit(type, value)
        },
        validFeedBackPasswordHistory(passwordUnique) {
            if (this.$props.includePasswordHistory && passwordUnique) {
                console.log(`result: ${passwordUnique}`);
                return "password__feedback password__feedback--valid"
            } else {
                return "password__feedback password__feedback--invalid"
            }
        },
        validIconPasswordHistory(passwordUnique) {
            if (this.$props.includePasswordHistory && passwordUnique) {
                console.log(`result: ${passwordUnique}`);
                return "lnr lnr-checkmark-circle"
            } else {
                return "lnr lnr-cross-circle"
            }
        },
        validFeedBack(regex) {
            return regex.test(this.$props.value) ?
                    'password__feedback password__feedback--valid' :
                    'password__feedback password__feedback--invalid'
        },
        validIcon(regex) {
            return regex.test(this.$props.value) ?
                    'lnr lnr-checkmark-circle' :
                    'lnr lnr-cross-circle';
        }
    }
}
</script>

<style scoped>

</style>
